import { FormikErrors } from 'formik'

import AgentService from '../../../core/services/agent.service'
import {
  biggerThanZero,
  required,
  validEmail,
  validSwissPostalCode,
} from '../../_utils/formValidators'
import { PolicyholderDataInfoValues } from './PolicyholderData.view'

const validateEmail = (email: string) => {
  return required.default(email) || validEmail.default(email)
}

const validatePostalCode = (postalAddress: string) => {
  return (
    required.default(postalAddress) ||
    validSwissPostalCode.default(postalAddress)
  )
}

const validatePrivacyPolicy = (checkboxChecked: boolean) => {
  return biggerThanZero('validator.privacyPolicySelected')(
    Number(checkboxChecked),
  )
}

export const validateFieldForm = (
  formValueFields: PolicyholderDataInfoValues,
) => {
  const errors: FormikErrors<PolicyholderDataInfoValues> = {}

  if (required.default(formValueFields.company)) {
    errors.company = required.default(formValueFields.company)
  }

  if (required.default(formValueFields.firstName)) {
    errors.firstName = required.default(formValueFields.firstName)
  }

  if (required.default(formValueFields.lastName)) {
    errors.lastName = required.default(formValueFields.lastName)
  }

  if (validateEmail(formValueFields.email)) {
    errors.email = validateEmail(formValueFields.email)
  }

  if (required.default(formValueFields.country)) {
    errors.country = required.default(formValueFields.country)
  }

  if (required.default(formValueFields.postalAddress)) {
    errors.postalAddress = required.default(formValueFields.postalAddress)
  }

  if (validatePostalCode(formValueFields.postalCode)) {
    errors.postalCode = validatePostalCode(formValueFields.postalCode)
  }

  if (required.default(formValueFields.city)) {
    errors.city = required.default(formValueFields.city)
  }

  if (
    !AgentService.isAgentOrBroker() &&
    validatePrivacyPolicy(formValueFields.acceptedPrivacyPolicy)
  ) {
    errors.acceptedPrivacyPolicy = validatePrivacyPolicy(
      formValueFields.acceptedPrivacyPolicy,
    )
  }

  return errors
}
